import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/dashboard/v1`;

export function getTotalEmployee() {
  const result = axios({
    method: "GET",
    url: `${url}/count_employee`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getCountPending() {
  const result = axios({
    method: "GET",
    url: `${url}/count_pending`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getAbsentEmployees(offset, limit) {
  const result = axios({
    method: "GET",
    url: `${url}/absent_employees?offset=${offset}&limit=${limit}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}

export function getLeavesRequest(offset, limit) {
  const result = axios({
    method: "GET",
    url: `${url}/leaves_request?offset=${offset}&limit=${limit}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}

export function getOvertimeRequest(offset, limit) {
  const result = axios({
    method: "GET",
    url: `${url}/overtimes_request?offset=${offset}&limit=${limit}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}

export function getLatePermission(offset, limit) {
  const result = axios({
    method: "GET",
    url: `${url}/late_permission?offset=${offset}&limit=${limit}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}

export function getEarlyPermission(offset, limit) {
  const result = axios({
    method: "GET",
    url: `${url}/early_permission?offset=${offset}&limit=${limit}`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}

export function getSummaryRequest() {
  const result = axios({
    method: "GET",
    url: `${url}/summaries_request`,
    headers: getHeaders(),
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
}
